module.exports = __webpack_public_path__ + "img/phone.2657fc4a.png";